import React from 'react';
import TeacherForm from '../../../components/forms/TeacherForm';

export default function TeachersCreatePage() {
  return <TeacherForm />;
}
